import { DateRangeOutlined } from "@mui/icons-material";
import { DatePresetMenu } from "@/components/DatePresetMenu";
import { IMPACT_REPORT_CONTROL_LABELS } from "@/constants/impactReport";
import { useImpactReportContext } from "@/context/ImpactReportContext";

/**
 * The DATE control. Its body now lives in the shared, prop-driven `DatePresetMenu`, because a
 * second screen needs the same six presets; all that is left here is the report's own wiring.
 */
export function ImpactPeriodMenu() {
  const { controls, setControls, dateMenuTriggerRef } = useImpactReportContext();

  return (
    <DatePresetMenu
      value={controls.date}
      onChange={(date) => setControls((previous) => ({ ...previous, date }))}
      label={IMPACT_REPORT_CONTROL_LABELS.date}
      icon={<DateRangeOutlined />}
      buttonAriaLabel="Date range"
      menuMinWidth={280}
      // The empty state's "widenDate" action focuses this button directly — see
      // `dateMenuTriggerRef` on the context for why.
      triggerButtonRef={dateMenuTriggerRef}
    />
  );
}
